import { IdentifierString } from '@iota/wallet-standard';

import { mainApi, queryFnNotifyWrapper } from 'modules/api';
import { closeDialog, KnownDialogs, selectDialogState } from 'modules/dialogs';

import { authCacheTags } from '../authCacheTags';
import { CONNECTION_CACHE_KEY, WalletId } from '../const';
import { getIotaProvider } from '../utils/getIotaProvider';
import { storeWalletId } from '../utils/storeWalletId';

interface IResult {
  address: string;
  walletId: WalletId;
  chainId: IdentifierString;
}

type Args = string;

export const {
  useConnectMutation,
  endpoints: { connect },
} = mainApi.injectEndpoints({
  endpoints: build => ({
    connect: build.mutation<IResult, Args>({
      queryFn: queryFnNotifyWrapper<Args, void, IResult>(async walletId => {
        const provider = await getIotaProvider(walletId);

        if (!provider.walletId) {
          throw new Error("Wallet id hasn't been found");
        }

        const accountData = provider.getWalletAccount();

        const data: IResult = {
          address: accountData.address,
          walletId: provider.walletId,
          chainId: accountData.chains[0],
        };

        return { data };
      }),
      async onQueryStarted(_arg, { queryFulfilled, dispatch, getState }) {
        return queryFulfilled.then(({ data }) => {
          const { walletId = '' } = data;
          storeWalletId(walletId);

          const state = getState() as unknown as Parameters<
            typeof selectDialogState
          >[0];
          const { currentModal } = selectDialogState(state);

          if (currentModal === KnownDialogs.connect) {
            dispatch(closeDialog());
          }
        });
      },
      invalidatesTags: [authCacheTags.account],
    }),
  }),
});

export const selectConnect = connect.select({
  fixedCacheKey: CONNECTION_CACHE_KEY,
  requestId: undefined,
});
